export interface SupplementsTypes {
  administration: string,
  administrationRoute: string,
  administrationRouteType: string,
  administrationType: string,
  applicationTime: string,
  diluent: string,
  diluentDose: number,
  diluentId: number,
  diluentUnitMeasure: string,
  diluentUnitMeasureId: string,
  dosageType: string,
  dose: number,
  duration: string,
  durationType: string,
  endDate: string,
  hours: string,
  id: number,
  infusionBomb: string,
  infusionSpeed: number,
  interval: string,
  justification: string,
  material: string,
  materialId: number,
  measurementUnit: string,
  measurementUnitId: string,
  observation: string,
  orientation: string,
  prescriberDt: string,
  prescriberName: string,
  startDate: string,
  totalVolume: number
}

export enum AdministrationRouteType {
  ENTERAL = 'Ent',
  URETHRAL_ROUTE = 'UR'
}